import { render, staticRenderFns } from "./SocialNetworksEditor.vue?vue&type=template&id=aedb6ffe&"
import script from "./SocialNetworksEditor.vue?vue&type=script&lang=js&"
export * from "./SocialNetworksEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports